<main class="flex justify-content-center">
  <div class="reports-page">
    <h2>Automated Validation Reports</h2>

    @if (seriesList.length > 1) {
      <div class="series-select">
        <p-floatLabel class="mb-4 mt-3">
          <p-select
            [inputId]="seriesSelectorId"
            (onChange)="onSeriesChange($event.value)"
            [options]="seriesList"
            [(ngModel)]="selectedSeries"
            [filter]="true"
            [style]="{ width: '100%' }"
          />
          <label for="{{ seriesSelectorId }}">Report series</label>
        </p-floatLabel>
      </div>
    }

    @if (selectedSeries) {

      <p-accordion class="intro-accordion">
        <p-accordion-panel value="intro">
          <p-accordion-header>What is this?</p-accordion-header>
          <p-accordion-content>
            <p class="page-intro">
              @for (segment of seriesIntro; track $index) {
                @if (segment.href) {
                  <a [href]="segment.href" target="_blank" rel="noopener noreferrer">{{ segment.text }}</a>
                } @else {
                  <span>{{ segment.text }}</span>
                }
              }
            </p>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>

      <h3>{{ selectedSeries }}</h3>

      <div class="legend" aria-label="Indicator legend">
        @for (key of indicatorKeys; track key) {
          <span class="legend-item">
            <span [class]="legendDotClass(key)"></span>{{ indicatorLabels[key] }}
          </span>
        }
      </div>
    }

  
    <div class="hint">
      <p>If you are interested in setting up automated validation reports for your data production system, please contact support@qa4sm.eu</p>
    </div>

    @if (loading) {
      <p>Loading reports…</p>
    }

    @if (!loading && latestReport) {
      <div class="latest-card">
        <div class="latest-info">
          <span [class]="dotClass(latestReport)" [title]="indicatorTitle(latestReport)"></span>
          <div>
            <div class="latest-title">
              Latest report — {{ latestReport.report_date_iso }}
            </div>
            <div class="meta">
              {{ latestReport.filename }} · generated
              {{ formatCreation(latestReport.creation_date) }}
            </div>
          </div>
        </div>
        <div class="latest-actions">
          <a class="action-link" [href]="reportUrl(latestReport)" target="_blank">
            Open
          </a>
          <button
            type="button"
            class="action-button"
            (click)="copyLink(latestUrl())"
          >
            {{ copiedUrl === latestUrl() ? "Link copied" : "Copy latest link" }}
          </button>
        </div>
      </div>
      <p class="hint">
        The latest report link always points to the newest report of this series.
        To cite a specific report, use its own link instead.
      </p>
    }

    @if (!loading && yearGroups.length) {
      <p-accordion [multiple]="true" [(value)]="activeYears">
        @for (group of yearGroups; track group.year) {
          <p-accordion-panel [value]="group.year">
            <p-accordion-header>
              <span class="year-header">
                <span class="year-label">{{ group.year }}</span>
                <span class="report-count">
                  {{ group.reports.length }}
                  report{{ group.reports.length === 1 ? "" : "s" }}
                </span>
                <span class="year-badges">
                  @for (key of indicatorKeys; track key) {
                    @if (indicatorCount(group, key); as n) {
                      <span [class]="badgeClass(key)" [title]="indicatorLabels[key]">
                        {{ n }}
                      </span>
                    }
                  }
                </span>
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <ul class="report-list">
                @for (report of group.reports; track report.filename) {
                  <li class="report-row">
                    <span [class]="dotClass(report)" [title]="indicatorTitle(report)"></span>
                    <div class="report-main">
                      <a [href]="reportUrl(report)" target="_blank">
                        {{ report.filename }}
                      </a>
                      <span class="meta">
                        report date {{ report.report_date_iso }} · generated
                        {{ formatCreation(report.creation_date) }}
                      </span>

                      @if (report.previous_versions?.length) {
                        <details class="versions">
                          <summary>
                            {{ report.previous_versions?.length }} earlier
                            version{{ report.previous_versions?.length === 1 ? "" : "s" }}
                          </summary>
                          <ul>
                            @for (old of report.previous_versions ?? []; track old.filename) {
                              <li>
                                <span [class]="dotClass(old)" [title]="indicatorTitle(old)"></span>
                                <a [href]="reportUrl(old)" target="_blank">
                                  {{ old.filename }}
                                </a>
                                <span class="meta">
                                  generated {{ formatCreation(old.creation_date) }}
                                </span>
                                <button
                                  type="button"
                                  class="action-button"
                                  (click)="copyLink(reportUrl(old))"
                                >
                                  {{ copiedUrl === reportUrl(old) ? "Copied" : "Copy link" }}
                                </button>
                              </li>
                            }
                          </ul>
                        </details>
                      }
                    </div>
                    <button
                      type="button"
                      class="action-button"
                      (click)="copyLink(reportUrl(report))"
                    >
                      {{ copiedUrl === reportUrl(report) ? "Copied" : "Copy link" }}
                    </button>
                  </li>
                }
              </ul>
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    }

    @if (!loading && selectedSeries && !yearGroups.length) {
      <p>No reports available for this series.</p>
    }
  </div>
</main>
